import { render, staticRenderFns } from "./BankInformation.vue?vue&type=template&id=0a507a3e&scoped=true&"
import script from "./BankInformation.vue?vue&type=script&lang=js&"
export * from "./BankInformation.vue?vue&type=script&lang=js&"
import style0 from "./BankInformation.vue?vue&type=style&index=0&id=0a507a3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a507a3e",
  null
  
)

export default component.exports